import React from 'react';

import { TableRow } from '../../../components/TableRow/TableRow';

const PreCheckRow = (props) => {
    return (
        <TableRow pseudoTable title={props.title} textColor={props.textColor} onClick={props.onClick}>
            {props.text}
        </TableRow>
    );
};
export default PreCheckRow;
